<template>
	<div class="cls-btn" :class="{ rotate }">
		<v-btn @click.stop="$emit('click')">
			<AppIcon name="close" />
		</v-btn>
	</div>
</template>
<script>
export default {
	name: 'CloseButton',
	props: { rotate: { type: Boolean, default: false } },
};
</script>
<style lang="scss" scoped>
.cls-btn {
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2) !important;
	border-radius: 4px;
	cursor: button;

	&.rotate {
		transform: rotate(180deg);
	}

	::v-deep {
		button {
			width: 50px;
		}
		svg {
			margin-top: 8px;
		}
	}
}
</style>
